<template>
  my center
  <i class="iconfont">&#xe600;</i>
</template>

<script>
export default {};
</script>

<style></style>
